/**
 * Wrapper class for window.setTimeout().
 */
var Timer = /** @class */ (function () {
    function Timer(pHandler) {
        var _this = this;
        this.onTimeout = function () {
            _this.mTimer = null;
            _this.mHandler();
        };
        this.mHandler = pHandler;
    }
    Object.defineProperty(Timer.prototype, "isRunning", {
        /** true if timer was started */
        get: function () {
            return (this.mTimer != null);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts the timer. The handler will be executed only once if consecutive calls are
     * made before the timeout.
     * @param pTimeout Timeout in milliseconds for the timer.
     * @param pRestart If true and the timer is currently running, the timer will be restartet
     * with the new timeout. If false the currently running timer will
     * stay active and the new timeout is ignored. (default: false)
     */
    Timer.prototype.start = function (pTimeout, pRestart) {
        if (pRestart === void 0) { pRestart = false; }
        if (this.isRunning) {
            if (pRestart) {
                this.stop();
            }
            else {
                return; // do nothing
            }
        }
        this.mTimer = window.setTimeout(this.onTimeout, pTimeout);
    };
    /** stops the timmer if it is currently running */
    Timer.prototype.stop = function () {
        if (this.mTimer != null) {
            clearTimeout(this.mTimer);
            this.mTimer = null;
        }
    };
    return Timer;
}());
export { Timer };
export default Timer;
